import React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux'

const SearchTags = (props) => {
    const { isChannelTags, toggleTags, messages } = props
    return (
        <SearchTagsWrap>
            <SearchTagsContent active={isChannelTags} onClick={()=> toggleTags(true)}>{messages.info_list_channel_search}</SearchTagsContent>
            <SearchTagsContent id={"user_tour_infolist_5"} active={!isChannelTags} onClick={()=> toggleTags(false)}>{messages.info_list_video_search}</SearchTagsContent>
        </SearchTagsWrap>
    )
}
const mapStateToProps = state => {
    return {
        messages: state.Messages,
    }
}
export default connect(mapStateToProps)(SearchTags);

const SearchTagsWrap = styled.div`
    position: absolute;
    display: flex;
    width: 100%;
    top: -24px;
`
const SearchTagsContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 24px;
    padding: 10px 20px;
    border-radius: 6px 6px 0 0;
    background-color: #e94242;
    font-size: 14px;
    font-weight: 300;
    color: #fff;
    cursor: pointer;
    opacity: ${props => props.active ? `1` : `.6`};
` 



// WEBPACK FOOTER //
// ./src/InfoList/Search/SearchTags.js